// RoleSelector.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const RoleSelector = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <h1>Select Your Role</h1>
      <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
        <button className="large-bttn" onClick={() => navigate('/provider-login')}>
          I am a Provider
        </button>
        <button className="large-bttn" onClick={() => navigate('/patient-login')}>
          I am a Patient
        </button>
      </div>
    </div>
  );
};
